import refreshAccessToken from "../../../../utils/refreshAccessToken";
import api from "../../instance";

let isRefreshing = false;
let failedQueue = [];

function processQueue(error, token = null) {
    failedQueue.forEach(prom => {
        if (error) prom.reject(error);
        else prom.resolve(token);
    });

    failedQueue = [];
}


export default async function handleUnAuthorizedError(error){
    const originalRequest = error.config;

    if(originalRequest._retry) {
        return Promise.reject(error);
    }

    originalRequest._retry = true;

    if (isRefreshing) {
        return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
        }).then(token => {
            originalRequest.headers.Authorization = "bearer " + token;
            return api(originalRequest);
        }).catch(err => Promise.reject(err));
    }

    isRefreshing = true;

    try {
        const data = await refreshAccessToken();

        processQueue(null, data.accessToken);

        originalRequest.headers.Authorization = `bearer ${data.accessToken}`;
        
        return api(originalRequest);
    } catch (_) {   
        return Promise.reject(error);
    } finally {
        isRefreshing = false;
    }
}